/**
 * Shape pre-filter for the signup field. The server is authoritative (FR-004);
 * this only spares the visitor a round trip for an obviously malformed address.
 *
 * The grammar is the WHATWG HTML5 "valid e-mail address" production — the same
 * one `<input type="email">` applies in the browser, and character-for-character
 * the one Rails ships as `URI::MailTo::EMAIL_REGEXP`, which `EmailSubscriber`
 * validates against. Keeping the two in step is deliberate: the form must never
 * reject an address the API would have accepted.
 *
 * Consequences worth knowing: a dotless domain such as `visitor@localhost` is
 * valid, and no deliverability claim is made — only the address' shape.
 */
const HTML5_EMAIL_PATTERN =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export function validateEmail(value: string): boolean {
  return HTML5_EMAIL_PATTERN.test(value.trim());
}
